import React, { Component } from "react";
import { connect } from "react-redux";
import DropzoneComponent from "react-dropzone-component";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { graphql, gql, compose } from "react-apollo";
import s from "!isomorphic-style-loader!css-loader!./filepicker.css";

// import DocumentList from "../DocumentList"; // We will show a single document inline, not the full list.

import showToaster from "../../helpers/toasterMessages/showToaster";

import PictureImage from "/public/SiteIcons/photoUpload.svg";



class DocumentUpload extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isUploading: false,
      uploadedDocument: props.uploadedDocument || null,
    };
    this.dropzone = null;
  }

  componentDidMount() {
    const isBrowser = typeof window !== "undefined";
    const isDocument = typeof document !== undefined;
    if (isBrowser && isDocument) {
      document.querySelector(".dz-hidden-input").style.visibility = "visible";
      document.querySelector(".dz-hidden-input").style.opacity = "0";
      document.querySelector(".dz-hidden-input").style.height = "100%";
      document.querySelector(".dz-hidden-input").style.width = "100%";
      document.querySelector(".dz-hidden-input").style.cursor = "pointer";
    }
  }

  complete = async (file) => {
    try {
      this.setState({ isUploading: true, error: null });
      const { onUpload, refreshUploadedDocument } = this.props;

      if (file && file.xhr) {
        const { files } = JSON.parse(file.xhr.response);
        const uploadedFile = files[0].filename;

        if (onUpload) {
          await onUpload(uploadedFile);
        }
        // Refresh the uploaded document for this step/category
        if (refreshUploadedDocument) {
          await refreshUploadedDocument();
        }
      }
    } catch (error) {
      this.setState({ error: error.message });
      showToaster({
        messageId: error.message || "Failed to upload document",
        toasterType: "error",
      });
    } finally {
      this.setState({ isUploading: false });
      if (this.dropzone && file) {
        this.dropzone.removeFile(file);
      }
    }
  };

  componentDidUpdate(prevProps) {
    // If uploadedDocument prop changes, update local state
    if (
      this.props.uploadedDocument &&
      this.props.uploadedDocument !== prevProps.uploadedDocument
    ) {
      this.setState({ uploadedDocument: this.props.uploadedDocument });
    }
  }

  addedfile = (file) => {
    const { maxUploadSize } = this.props;
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (file.size > 1024 * 1024 * parseInt(maxUploadSize)) {
      this.dropzone.removeFile(file);
      showToaster({
        messageId: `File size should be less than ${maxUploadSize}MB`,
        toasterType: "error",
      });
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      showToaster({
        messageId: "Only JPG, PNG and PDF files are allowed",
        toasterType: "error",
      });
      this.dropzone.removeFile(file);
      return;
    }
  };

  render() {
    const { placeholder } = this.props;
    const { error, isUploading, uploadedDocument } = this.state;
    const { category } = this.props;

    const djsConfig = {
      dictDefaultMessage: "",
      addRemoveLinks: false,
      maxFilesize: 10,
      maxFiles: 1,
      acceptedFiles: "image/*,application/pdf",
      hiddenInputContainer: ".dzInputContainer",
    };
    const componentConfig = {
      iconFiletypes: [".jpg", ".png", ".pdf"],
      postUrl: "/documents",
    };
    const eventHandlers = {
      init: (dz) => (this.dropzone = dz),
      complete: this.complete,
      addedfile: this.addedfile,
    };

    return (
      <div className={cx("listPhotoContainer")}>
        <div className={cx("dzInputContainer")}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
            disabled={isUploading}
          >
         
            <img src={PictureImage} className={"photoUploadImg"} alt="Upload" />
            <span className={cx("documentPlaceholder")}>
              {isUploading ? "Uploading..." : placeholder}
            </span>
          </DropzoneComponent>
          {error && <div className={cx("errorMessage")}>{error}</div>}
        </div>
    
    
      </div>
    );
  }
}

const mapState = (state) => ({
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize,
});

const mapDispatch = {};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch)
  // graphql(UPLOAD_DOCUMENT)
)(DocumentUpload);
